import { useQuery } from "@tanstack/react-query";
import { apiRelProdutoresSimp } from "pages/relatorios/api/apiRelProdutoresSimp";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import type { ApiRota } from "pages/rota/types/ApiRota";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBar } from "./FilterBar";
import { columns, TableRelCadastroProdutorSimp } from "./TableRelCadastroProdutorSimp";

export function RelatorioCadastroProdutorSimp() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelProdutoresSimp", params],
		queryFn: () => apiRelProdutoresSimp({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<ApiRota> = useMemo(() => {
		return {
			type: "multitable",
			fileName: "relatorio-cadastros-produtor-simples",
			options: {
				// biome-ignore lint/suspicious/noExplicitAny: dynamic
				columns: columns as any,
				data: registros,
				parentColumn: "rot_identificacao",
				childKey: "fornecedor",
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados cadastrais do produtor simples";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Produtor", "Simples"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelCadastroProdutorSimp data={data?.registros} title={title} />}
		/>
	);
}
